
import api from './api';
import session from './session';
import storage from './storage';

class Sso {

	constructor (Api, Session, Storage) {
		this.Api = Api;
		this.Session = Session;
		this.Storage = Storage;
	}

	ssoLogin (code, state) {
		return this.Api.post({
			url:  'v1.1/m/auth/sso/login?code=' + code + '&state=' + state,
		}).then(response => {
			this.Session.set('worker',      false);
			this.Session.set('user',        response.marketer);
			this.Session.set('brandObject', response.brand);
			this.Session.set('brand',       response.brand.name);
			return response.marketer;
		});
	}

	setGroup (group) {
		this.Storage.set('sso', { group: group });
	}

	getGroup () {
		const sso = this.Storage.get('sso');
		return sso && sso.group || '';
	}

	getBrands (group) {
		return this.Api.get({
			url:  'v1.1/m/auth/sso/brands?group=' + group,
		}).then(response => {
			return response.brands;
		});
	}

}

Sso.$inject = ['Api', 'Session', 'Storage'];

export default angular.module('service.sso', [api, session, storage])
	.service('Sso', Sso)
	.name;




// WEBPACK FOOTER //
// ./src/service/sso.js